import React, { useCallback } from 'react';
import Checkbox from '@material-ui/core/Checkbox';

type CheckboxFieldProps = Omit<React.ComponentProps<typeof Checkbox>, 'checked' | 'onChange'> & {
    onChange: (value: boolean) => void;
    value: boolean;
};

const CheckboxField = ({ onChange, value, ...restProps }: CheckboxFieldProps): React.ReactElement => {
    const handleOnChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
        [onChange]
    );

    return <Checkbox checked={value} onChange={handleOnChange} {...restProps} />;
};

export default CheckboxField;
